<template>
    <b-modal
        has-modal-card
        :active.sync="_active"
        :canCancel="false"
        :class="className"
    >
        <div class="confirm-modal-wrapper">
            <slot name="body">
                <span v-html="text"></span>
            </slot>
            <div class="modal-button-wrapper">
                <button @click="cancel">{{ _cancelText }}</button>
                <button @click="confirm">{{ _confirmText }}</button>
            </div>
        </div>
    </b-modal>
</template>

<script>
var defaultCb = R.always(undefined);

export default {
    props: {
        text: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false,
        },
        confirmCb: {
            type: Function,
            default: defaultCb,
        },
        cancelCb: {
            type: Function,
            default: defaultCb,
        },
        confirmText: {
            type: String,
        },
        cancelText: {
            type: String,
        },
        className: String,
        children: undefined,
    },
    computed: {
        _active: {
            get() {
                return this.active;
            },
            set(value) {
                this.$emit('update:active', value);
            },
        },
        _confirmText() {
            return this.confirmText || this.$t('COMMON.ok');
        },
        _cancelText() {
            return this.cancelText || this.$t('COMMON.cancel');
        },
    },
    methods: {
        confirm() {
            this._active = false;
            this.$emit('confirm');
            this.confirmCb();
        },
        cancel() {
            this._active = false;
            this.$emit('cancel');
            this.cancelCb();
        },
    },
};
</script>

<style lang="scss" scoped>
.confirm-modal-wrapper {
    max-width: 450px;
    border-radius: 10px;
    padding: 30px 15px 15px 15px;
    display: flex;
    flex-direction: column;
    background-color: white;
    position: relative;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    transform: translateY(-3%);

    .modal-button-wrapper {
        display: flex;
        justify-content: space-between;
    }
    button {
        width: 205px;
        margin-top: 30px;
        font-size: 18px;
        font-family: $font-common;
        font-weight: 600;
        color: white;
        border-radius: 5px;
        height: 50px;

        &:first-child {
            background-color: $color4;
            margin-right: 5px;
        }

        &:last-child {
            background-color: $color21;
            margin-left: 5px;
        }
    }

    span {
        text-align: center;
        font-family: $font-common;
        font-size: 16px;
        color: $color12;
    }
}
</style>
